import { UseCase } from '../../UseCase';
import { DashboardEntity } from '../../../models/index';

export namespace GetParameter {
    export interface Params {
        params?: DashboardEntity;
        name: string;
    }
}

export class GetParameter implements UseCase<GetParameter.Params, string | undefined> {
    execute<V extends string | number>({ params, name }: GetParameter.Params): V | undefined {
        if (params) {
            return params[name];
        }
    }
}
